import React from 'react';
import { Card } from '../ui/Card';
export function TemperatureLegend() {
  return <Card className="absolute bottom-24 right-6 z-[1000] p-3 w-[320px] bg-[#111827]/90 backdrop-blur border-slate-700/50" data-id="element-992">
      <div className="flex items-center justify-between mb-2" data-id="element-993">
        <span className="text-xs font-semibold text-white" data-id="element-994">
          Air Temperature @ 2m [°C]
        </span>
      </div>

      {/* Gradient Bar */}
      <div className="h-2 w-full rounded-full mb-1" style={{
      background: 'linear-gradient(to right, #3b82f6, #06b6d4, #22c55e, #eab308, #f97316, #ef4444, #ec4899)'
    }} data-id="element-995" />

      {/* Labels */}
      <div className="flex justify-between text-[10px] text-slate-400 font-medium px-1" data-id="element-996">
        <span data-id="element-997">-50</span>
        <span data-id="element-998">-30</span>
        <span data-id="element-999">-10</span>
        <span data-id="element-1000">10</span>
        <span data-id="element-1001">30</span>
        <span data-id="element-1002">50</span>
      </div>
    </Card>;
}